import { FC } from 'react'

import { IconContainerCustom, IIconContainer } from './IconContainer.styles'

const IconContainer: FC<IIconContainer> = ({ children, selected }) => {
  return (
    <IconContainerCustom selected={selected} className="icon-container">
      {children}
    </IconContainerCustom>
  )
}

export default IconContainer
